module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp3_1.9a361475.png";